import type { PrivacyBlock } from '@/content/privacy.types';

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[’‘'"“”]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function parsePrivacyMarkdown(markdown: string): PrivacyBlock[] {
  const lines = markdown.split(/\r?\n/);
  const blocks: PrivacyBlock[] = [];
  const usedIds = new Set<string>();
  let listBuffer: string[] = [];

  const flushList = () => {
    if (listBuffer.length > 0) {
      blocks.push({ kind: 'list', items: listBuffer });
      listBuffer = [];
    }
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (line === '') {
      flushList();
      continue;
    }

    const headingMatch = line.match(/^(#{1,4})\s+(.*)$/);
    if (headingMatch) {
      flushList();
      const level = headingMatch[1].length as 1 | 2 | 3 | 4;
      const text = headingMatch[2].trim();
      let id: string | undefined;
      if (level === 2 || level === 3) {
        let slug = slugify(text);
        let suffix = 2;
        while (usedIds.has(slug)) {
          slug = `${slugify(text)}-${suffix}`;
          suffix += 1;
        }
        usedIds.add(slug);
        id = slug;
      }
      blocks.push({ kind: 'heading', level, text, id });
      continue;
    }

    const listMatch = line.match(/^-\s+(.*)$/);
    if (listMatch) {
      listBuffer.push(listMatch[1].trim());
      continue;
    }

    flushList();
    blocks.push({ kind: 'paragraph', text: line });
  }

  flushList();
  return blocks;
}
